import React from 'react'
import DefaultLink from './DefaultLink'
import { getAssetUrl } from '../helper/BaseUrl';
import { DateConvert } from '../helper/DateConvert'


export default function BlogCard({ allData, visibleCount, btnText = "Read More", isBlogList }) {
  return (
    <>
      {
        allData?.slice(0, visibleCount).filter((item) => item?.slug).map((item, index) => {
          const thumbnailUrl = getAssetUrl(item?.thumbnail);
          return (
         <div className='col-lg-4 col-md-6' key={index}>
          <div className='press-list-box'>
            <div className='calendar-main-box'>
              {isBlogList ?
                <p><img src='/assets/images/blog-dot-icon.webp' className='blog-card-dot' alt="Calendar" />{item?.category_name} </p>
                :
                <p><img src='/assets/images/calendar-icon.webp' alt="Calendar" />{DateConvert(item?.date)} </p>
              }
            </div>
            {thumbnailUrl && <img src={thumbnailUrl} alt={item?.alt_thumbnail || item?.title || "Blog thumbnail"} />}
            <label>{item?.title?.slice(0, 60) + "..."} </label>
            <div className="card-overlay">
              <DefaultLink to={isBlogList ? `/blog-details/${item?.slug}` : `/press-release/${item?.slug}`} text={btnText} />
            </div>
          </div>
        </div>
          );
        })
      }
    </>
  )
}
